import { render, staticRenderFns } from "./tagQuery.vue?vue&type=template&id=0ef8d750&scoped=true&"
import script from "./tagQuery.vue?vue&type=script&lang=js&"
export * from "./tagQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef8d750",
  null
  
)

component.options.__file = "tagQuery.vue"
export default component.exports